import { render, staticRenderFns } from "./histogramData.vue?vue&type=template&id=005fede9&scoped=true"
import script from "./histogramData.vue?vue&type=script&lang=js"
export * from "./histogramData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005fede9",
  null
  
)

export default component.exports